import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Button } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import { getMatchOption } from '../../../shared/selectFn';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

const { Option } = Select;

export default function Filter(props, context) {
    const { searchParams, area, business, update, onSearch, onExport, onChange } = props;
    const { configure } = context;
    const { COMPLAINT_FROM = [], COMPLAINT_RISK = [], MAIN_RESPONSIBLE = [], IS_COMPLETED = [] } = configure;
    
    const handleChange = (value, key) => {
        switch (key) {
            case 'queryInvestigation':
            case 'complaintedUser':
            case 'disease': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                break;
            }
            case 'investigationAreaId':
                searchParams.diseaseId = undefined;
                searchParams.diseaseName = undefined;
            case 'lineOfBusiness':
                searchParams.secondLineName = undefined;
            default: {
                searchParams[key] = value;
                break;
            }
        }
        onChange(searchParams);
    };

    const { childList } = getMatchOption(business, 'typeConfigureId', searchParams.lineOfBusiness);
    const complaintFromOption = COMPLAINT_FROM.map(i => <Option key={i.complaintConfigureId}>{i.optionValue}</Option>);
    const businessOption = business.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
    const secondLineOption = (childList || []).map(i => <Option key={i.typeValue}>{i.typeValue}</Option>);
    const areaOption = area.map(i => <Option key={i.investigationAreaId}>{i.investigationAreaName}</Option>);
    const complaintRiskOption = COMPLAINT_RISK.map(i => <Option key={i.complaintConfigureId}>{i.optionValue}</Option>);
    const mainResponsibleOption = MAIN_RESPONSIBLE.map(i => <Option key={i.optionValue}>{i.optionValue}</Option>);
    const isCompletedOption = IS_COMPLETED.map(i => <Option key={i.complaintConfigureId}>{i.optionValue}</Option>);

    return (
        <div className="search-bar" style={{ marginBottom: 16 }}>
           <div className="search-item">
                <label className="ui-label">投诉编号</label>
                <Input
                    placeholder="请输入"
                    style={{width: 100}}
                    value={searchParams.complaintRecordNumber}
                    onChange={e => handleChange(e.target.value, 'complaintRecordNumber')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">投诉来源</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 100}}
                    value={format('toString', searchParams.complaintFrom)}
                    onChange={value => handleChange(value, 'complaintFrom')}
                >
                    {complaintFromOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">项目简称</label>
                <SearchRetrieve
                    keyword='investigationName'
                    style={{ width: 160 }}
                    params={{ limit: 20 }}
                    placeholder="输入名称检索"
                    value={searchParams.queryInvestigationName}
                    url={API_URL.investigation.queryInvestigationByName}
                    config={{ id: 'investigationId', name: 'investigationName' }}
                    onChange={option => handleChange(option, 'queryInvestigation')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">项目编号</label>
                <Input
                    placeholder="请输入"
                    style={{width: 100}}
                    value={searchParams.investigationCode}
                    onChange={e => handleChange(e.target.value, 'investigationCode')}
                />
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">业务线</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 100}}
                    value={searchParams.lineOfBusiness}
                    onChange={value => handleChange(value, 'lineOfBusiness')}
                >
                    {businessOption}
                </Select>
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 140}}
                    disabled={!searchParams.lineOfBusiness}
                    value={searchParams.secondLineName}
                    onChange={value => handleChange(value, 'secondLineName')}
                >
                    {secondLineOption}
                </Select>
            </div>
            <div className="search-item">
                <label htmlFor="" className="ui-label">项目领域</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{ width: 100 }}
                    onChange={value => handleChange(value, 'investigationAreaId')}
                >
                    {areaOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">疾病</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 140 }}
                    params={{ investigationAreaId: searchParams.investigationAreaId }}
                    placeholder="输入名称检索"
                    url={API_URL.common.queryAllDisease}
                    value={searchParams.diseaseName}
                    config={{ id: 'diseaseId', name: 'diseaseName' }}
                    onChange={(option) => handleChange(option, 'disease')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">被投诉人</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 130 }}
                    params={{ limit: 20 }}
                    placeholder="输入姓名/工号检索"
                    value={searchParams.complaintedUserName}
                    url={API_URL.investigation.queryUserByKey}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={option => handleChange(option, 'complaintedUser')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">投诉风险等级</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 80}}
                    value={format('toString', searchParams.riskLevelId)}
                    onChange={value => handleChange(value, 'riskLevelId')}
                >
                    {complaintRiskOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">主要责任方</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 100}}
                    value={format('toString', searchParams.mainResponsibleName)}
                    onChange={value => handleChange(value, 'mainResponsibleName')}
                >
                    {mainResponsibleOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">投诉风险等级是否已确认</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 80}}
                    value={format('toString', searchParams.isCompleted)}
                    onChange={value => handleChange(value, 'isCompleted')}
                >
                    {isCompletedOption}
                </Select>
            </div>
            <div className="search-item">
                <Button type="primary" onClick={onSearch}>搜索</Button>
                <Button type="primary" onClick={onExport}>导出</Button>
                {
                    sessionStorage.curRole !== 'HRRC' && <Button type="primary" onClick={() => update('add', {})}>添加</Button>
                }
            </div>
        </div>
    );
}

Filter.contextTypes = {
    configure: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/Filter.js